import React, { useEffect, useState } from "react";
import "../styles/Dashboard.css";
import AdminPageLayout from "../components/AdminPageLayout";
import "../components/AdminPageLayout.css";
import RevenueByPlan from "../components/widgets/RevenueByPlan";
import MonthlyRevenue from "../components/widgets/MonthlyRevenue";
import UserGrowth from "../components/widgets/UserGrowth";
import FreeToPaidConversion from "../components/widgets/FreeToPaidConversion";
import axios from "axios";

const Dashboard = () => {
  const [data, setData] = useState({
    revenueByPlan: [],
    monthlyRevenue: [],
    userGrowth: [],
    freeToPaid: [],
  });

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const [revenueRes, monthlyRes, userRes, funnelRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_BASE_URL}/admin/analytics/revenue/by-plan`),
          axios.get(`${process.env.REACT_APP_BASE_URL}/admin/analytics/revenue/monthly`),
          axios.get(`${process.env.REACT_APP_BASE_URL}/admin/analytics/users-growth`),
          axios.get(`${process.env.REACT_APP_BASE_URL}/admin/analytics/free-paid-funnel`),
        ]);
        setData({
          revenueByPlan: revenueRes.data,
          monthlyRevenue: monthlyRes.data,
          userGrowth: userRes.data,
          freeToPaid: funnelRes.data,
        });
      } catch (error) {}
    };
    fetchDashboardData();
  }, []);

  return (
    <AdminPageLayout
      title="Dashboard"
      subtitle="Overview of revenue, user growth, and conversion metrics."
      instruction="Charts pull live data from the backend. Revenue by Plan shows earnings split across subscription tiers. Free-to-Paid Conversion tracks how many free users upgraded this month."
    >
      <div className="dashboard-grid">
        <RevenueByPlan data={data.revenueByPlan} />
        <MonthlyRevenue data={data.monthlyRevenue} />
        <UserGrowth data={data.userGrowth} />
        <FreeToPaidConversion data={data.freeToPaid} />
      </div>
    </AdminPageLayout>
  );
};

export default Dashboard;
